import { NoteModel } from '@/models/student-notes/note.model';
import { GetterTree } from 'vuex';
import { NoteState } from './state';
import RootState from '@/store/root_state';
import Sort from '@/helpers/sort';
import { filterGroupedNotes } from '@/helpers/groupedNotes';

const getters: GetterTree<NoteState, RootState> = {
  getVideoNotes: (state: NoteState, rootGetters) =>
    Object.keys(state.videoNotes)
      .filter((id) => state.videoNotes[id])
      .map((id) => ({
        ...state.videoNotes[id],
        profile: { ...rootGetters.profilesById[state.videoNotes[id].profileId] },
      })),
  getVideoNotesByVideoId: (state: NoteState, rootGetters) => (videoId: string) =>
    Object.keys(state.videoNotes)
      .filter((id) => state.videoNotes[id])
      .map((id) => ({
        ...state.videoNotes[id],
        profile: { ...rootGetters.profilesById[state.videoNotes[id].profileId] },
      }))
      .filter((note: NoteModel) => note.videoId === videoId)
      .sort(Sort.byField('videoTimeStamp')),
  getClassVideoNotes: (state: NoteState, rootGetters) =>
    Object.keys(state.classVideoNotes)
      .filter((id) => state.classVideoNotes[id])
      .map((id) => ({
        ...state.classVideoNotes[id],
        profile: { ...rootGetters.profilesById[state.classVideoNotes[id].profileId] },
      })),
  getClassNotesByVideoId: (state: NoteState, rootGetters) => (videoId: string) =>
    Object.keys(state.classVideoNotes)
      .filter((id) => state.classVideoNotes[id])
      .map((id) => ({
        ...state.classVideoNotes[id],
        profile: { ...rootGetters.profilesById[state.classVideoNotes[id].profileId] },
      }))
      .filter((note: NoteModel) => note.videoId === videoId && !note.draft)
      .sort(Sort.byField('videoTimeStamp')),
  getNotebookNotes: (state: NoteState) => state.groupedNotebookNotes,
  getFilteredNotebookNotes:
    (state: NoteState) =>
    (disciplineSelected: string, lessonSelected: string, videoSelected: string) => {
      return filterGroupedNotes(
        state.groupedNotebookNotes,
        disciplineSelected,
        lessonSelected,
        videoSelected,
      );
    },
  getSharedNotebook: (state: NoteState) => state.sharedNotebook,
  getOtherStudentSharedNotebook: (state: NoteState) => state.otherStudentSharedNotebook,
  isLoadingSharedNotebook: (state: NoteState) => state.isLoadingSharedNotebook,
  isLoadingNotebookNotes: (state: NoteState) => state.isLoadingNotebookNotes,
  isGeneratingSharedNotebookLink: (state: NoteState) => state.isGeneratingSharedNotebookLink,
  isLoadingNotes: (state: NoteState) => state.isLoadingNotes,
  isLoadingNewNoteSave: (state: NoteState) => state.isLoadingNewNoteSave,
  isConfirmationBoxOpened: (state: NoteState) => state.isConfirmationBoxOpened,
  isDeletingAnnotation: (state: NoteState) => state.isDeletingAnnotation,
};

export default getters;
